<template>
  <div>
    <FITModal ref="modal" reference="modal" :title="$t('osm.contents.general.delete')" @click="onClickModal">
      <div slot="body">
        <span v-html="$t('osm.contents.general.deletePolicyConfirm', {policyNumber: clickedRow.policyNumber, policyRef: clickedRow.policyReference})"></span>
      </div>
    </FITModal>
    <b-modal id="cbModal" size="lg" ref="cbModal" @ok="onClickCbModalOk" :ok-variant="cb.isFirstTimeClickedModalOk?'primary':'success'" cancel-variant="danger" @hidden="onHideCbModal" :title="$t('osm.contents.general.changeBusiness.title') + ' - ' + $t(`osm.contents.general.changeBusiness.${this.selectedChangeBusinessAction}`)">
      <div>
        <p v-html="changeBusinessConfirmContent"></p>
      </div>
      <div class="mt-3">
        <div class="w-50">
          <FITDatePicker v-if="selectedChangeBusinessAction" :label="$t(`osm.contents.general.changeBusiness.${selectedChangeBusinessAction}`) +' '+$t('general.date')" :width="8" v-model="cb.changeBusinessEffectDate" :placeholder="$t('general.selectDate')"></FITDatePicker>
        </div>
        <FITWorkflowFileUpload ref="fitFileUpload"></FITWorkflowFileUpload>
      </div>
      <div v-if="!cb.isFirstTimeClickedModalOk" class="my-4">
        <h5 v-html="changeBusinessWarning" style="color:red"></h5>
      </div>
      <FITAlert ref="cbErrorAlert" :alertContent="$t('general.updateError')" :alertSec="3" variant="danger"></FITAlert>
    </b-modal>
    <FITAlert ref="alert" :alertContent="alertParams.content" :alertSec="3" :variant="alertParams.variant"></FITAlert>
    <FITFormCard>
      <h4 slot="header">
      <b-row align-v="center">
          <b-col cols="6">
            {{this.$t('osm.contents.lifePolicy.lifePolicyList')}}
        </b-col>
        <b-col cols="6" class='text-right'>
          <b-btn v-if="permissionLevel < 3.5" variant="primary" size="md" @click="$router.push('transferIn')">{{$t('osm.contents.general.changeBusiness.transferIn')}}</b-btn>
          <b-btn v-if="permissionLevel < 3.5" variant="success" size="md" class="ml-2" @click="$router.push('/osm/life/new')">
            {{$t('osm.contents.general.create')}}
          </b-btn>
        </b-col>
      </b-row>
    </h4>
      <div slot="formBody">
        <b-row class=" mx-0 px-0" align-v="center">
          <!-- <b-col cols="auto">
          <FITButton v-bind="this.createBtn" @click="createAction('Create')"></FITButton>
        </b-col> -->
          <b-col cols="2">
            <FITSelect :width="8" v-model="policyStatus.value" :label="$t('osm.contents.lifePolicy.policyStatus')" :options="policyStatusList" @input="getDataList"></FITSelect>
          </b-col>
          <b-col cols="2">
            <FITSelect :width="8" v-model="workFlowStep.value" :label="$t('osm.contents.lifePolicy.currentWorkflow')" :options="workflowStepList" @input="getDataList"></FITSelect>
          </b-col>
          <b-col cols="auto" class="ml-auto mr-0">
            <b-row class="mx-0">
              <FITSelect class="pr-4" v-model="rowsPerPage.value" :label="$t('general.pagination.perPage')" :options="rowsPerPage.options" @input="setPerPage(rowsPerPage.value)"></FITSelect>
              <FITPagination v-model="pagination.currentPage" :perPage="rowsPerPage.value" :totalRows="totalItems.total" @input="setCurrentPage(pagination.currentPage)"></FITPagination>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mx-0 px-0">
          <b-col cols="4">
            <div class="form-group">
              <FITTextInput :label="$t('general.search')" :width="10" class="py-0" v-model="$v.searchInput.value.$model" v-bind="searchInput" @input="setSearch(searchInput.value)"></FITTextInput>
            </div>
          </b-col>
        </b-row>
        <div class="row mx-0 py-2">
          <b-table striped hover responsive no-local-sorting :slots="slots" :items="dataList" :fields="fields" class="minTableHeight" @sort-changed="onSortChanged">
            <!-- Actions Column Slot -->
            <template slot="productName" slot-scope="row">
              <div>{{row.item.productEnglishName | isEmpty}}</div>
              <div>{{row.item.productChineseName }}</div>
            </template>
            <template slot="workFlowStep" slot-scope="row">
              {{getTranslatedPolicyField('workFlowStep',row.item.workFlowStep)}}
            </template>
            <template slot="policyStatus" slot-scope="row">
              {{getTranslatedPolicyField('policyStatus',row.item.policyStatus)}}
            </template>
            <template slot="policyOwnerName" slot-scope="row">
              <div>{{row.item.englishFirstnamePolicyOwner}} {{row.item.englishLastnamePolicyOwner | capitalizeLastName}}</div>
              <div>{{row.item.chineseLastnamePolicyOwner}}{{row.item.chineseFirstnamePolicyOwner}}</div>
            </template>
            <template slot="currentAgentName" slot-scope="row">
              <div>{{row.item.agentEnglishName}}</div>
              <div>{{row.item.agentChineseName}}</div>
            </template>
            <template slot="approveAgentName" slot-scope="row">
              <div>{{row.item.englishFirstnameApproveAgent}} {{row.item.englishLastnameApproveAgent | capitalizeLastName}}</div>
              <div>{{row.item.chineseLastnameApproveAgent}}{{row.item.chineseFirstnameApproveAgent}}</div>
            </template>
            <template slot="actions" slot-scope="row">
              <FITDropdown v-model="actions.value.action" variant="primary" :text="actions.label" :options="actions.options" @clicked="onClickDropdown($event,row.item)"></FITDropdown>
            </template>
          </b-table>
        </div>
        <!-- Container Footer -->
        <div class="row mx-0 py-2">
          <b-col cols="auto" class="mr-auto align-self-center">
            <span class="text-secondary">{{ total }}</span>
          </b-col>
          <b-col cols="auto">
            <FITPagination v-model="pagination.currentPage" :perPage="rowsPerPage.value" :totalRows="totalItems.total" @input="setCurrentPage(pagination.currentPage)"></FITPagination>
          </b-col>
        </div>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import _ from 'lodash'
import { FITCheckbox, FITTextInput, FITCheckboxGroup, FITRadio, FITTextarea, FITSelect, FITDatePicker, FITTimepicker, FITvSelect, FITModal, FITAlert, FITWorkflowFileUpload } from '@/components'
import { FITButton, FITDropdown, FITPagination, FITFormGroup, FITTable, FITFormCard } from '@/components'
import { required, minLength, between } from 'vuelidate/lib/validators'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'lifePolicyList',
  props: {
    showRouteUpdateAlert: {
      type: Boolean,
      default: false
    },
    alertContent: {
      type: String,
      default: ''
    },
    alertVariant: {
      type: String,
      default: 'success'
    }
  },
  components: {
    FITButton,
    FITDropdown,
    FITTextInput,
    FITSelect,
    FITPagination,
    FITFormGroup,
    FITTable,
    FITFormCard,
    FITButton,
    FITModal,
    FITAlert,
    FITDatePicker,
    FITWorkflowFileUpload
  },
  created() {
    this.getOptions();
    this.getDataList();
  },
  mounted() {
    // console.debug(this.$route.params.showRouteUpdateAlert);
    // console.debug(this.showRouteUpdateAlert)
    if (this.showRouteUpdateAlert) {
      this.showUpdateSuccess();
    }
    if (this.alertContent.length > 0) {
      Vue.set(this.alertParams, 'content', this.alertContent);
      if (this.alertVariant.length > 0) {
        Vue.set(this.alertParams, 'variant', this.alertVariant);
      }
      this.$refs.alert.showAlert();
      window.scrollTo(0, 0);
    }
  },
  validations: {
    searchInput: {
      value: {
        required,
        minLength: minLength(5)
      }
    },
  },
  computed: {
    changeBusinessWarning() {
      return this.$t('osm.contents.general.changeBusiness.confirmActionWarning', {
        action: this.$t(`osm.contents.general.changeBusiness.${this.selectedChangeBusinessAction}`),
      })
    },
    changeBusinessConfirmContent() {
      return this.$t('osm.contents.general.changeBusiness.confirmActionContent', {
        policyOwner: this.clickedRow.policyOwner,
        policyReference: this.clickedRow.policyReference,
        policyNumber: this.clickedRow.policyNumber
      })
    },
    permissionLevel() {
      return this.$store.state.permissionLevel;
    },
    total() {
      return `${this.$t('osm.contents.general.page')} ${this.pagination.currentPage} / ${this.$t('osm.contents.general.total')} ${this.totalItems.total} ${this.$t('osm.contents.general.items')}`;
    },
    ...mapGetters("LifePolicy", [
      'getTranslatedOptions'
    ]),
    policyTypeList() {
      return this.getSpecificTranslatedOptions("policyType")
    },
    workflowStepList() {
      return this.getSpecificTranslatedOptions("workFlowStep")
    },
    policyStatusList() {
      return this.getSpecificTranslatedOptions("policyStatus")
    },

  },
  filters: {
    capitalizeLastName: function(value) {
      if (!value) return 'N/A'
      return value.toUpperCase();
    }
  },
  methods: {
    uploadFile() {
      var fileData = this.$refs.fitFileUpload.formUploadFiles();
      console.debug(fileData);
      Vue.set(this.cb, 'newFileUploaded', fileData);
      return fileData;
    },
    onHideCbModal() {
      Vue.set(this.cb, 'isFirstTimeClickedModalOk', true);
      Vue.set(this.cb, 'changeBusinessEffectDate', '');
      Vue.set(this.cb, 'newFileUploaded', {});
    },
    onClickCbModalOk(evt) {
      evt.preventDefault();
      if (this.cb.isFirstTimeClickedModalOk) {
        Vue.set(this.cb, 'isFirstTimeClickedModalOk', false);
        return;
      }
      var fileData = this.uploadFile();

      switch (this.selectedChangeBusinessAction) {
        case 'lapse':
          var params = { ID: this.clickedRow.policyID, policyLapseDate: this.cb.changeBusinessEffectDate, files: fileData.files, attachment: fileData.attachment }
          this.$store.dispatch('LifePolicy/lapseLife', params).then(() => {
            Vue.set(this, 'alertParams', { content: this.$t('general.updateSuccess'), variant: 'success' });
            this.$refs.cbModal.hide();
            this.$refs.alert.showAlert();
          }).catch((err) => {
            Vue.set(this.cb, 'isFirstTimeClickedModalOk', true);
            this.$refs.cbErrorAlert.showAlert();
          })

          break;
        case 'transferOut':
          var params = { ID: this.clickedRow.policyID, policyEndDate: this.cb.changeBusinessEffectDate, files: fileData.files, attachment: fileData.attachment };
          this.$store.dispatch('LifePolicy/transferOutLife', params).then(() => {
            Vue.set(this, 'alertParams', { content: this.$t('general.updateSuccess'), variant: 'success' });
            this.$refs.cbModal.hide();
            this.$refs.alert.showAlert();

          }).catch((err) => {
            Vue.set(this.cb, 'isFirstTimeClickedModalOk', true);
            this.$refs.cbErrorAlert.showAlert();
          })
          break;
        case 'coolingOff':
          var params = { ID: this.clickedRow.policyID, policyEndDate: this.cb.changeBusinessEffectDate, files: fileData.files, attachment: fileData.attachment };
          this.$store.dispatch('LifePolicy/coolingOff', params).then(() => {
            Vue.set(this, 'alertParams', { content: this.$t('general.updateSuccess'), variant: 'success' });
            this.$refs.cbModal.hide();
            this.$refs.alert.showAlert();

          }).catch((err) => {
            Vue.set(this.cb, 'isFirstTimeClickedModalOk', true);
            this.$refs.cbErrorAlert.showAlert();
          })
          break;
      }
    },
    onSortChanged(val) {
      Vue.set(this.sorting, 'orderBy', val.sortBy)
      Vue.set(this.sorting, 'direction', (val.sortDesc) ? 'desc' : 'asc')
    },
    onClickModal(event) {
      if (!event) {
        return;
      }
      this.$store.dispatch('LifePolicy/deleteLifePolicy', this.clickedRow.policyID).then((json) => {
        Vue.set(this, 'alertParams', { content: this.$t('osm.contents.general.deleteSuccess'), variant: 'success' });
        this.getDataList();
        this.$refs.alert.showAlert();
        window.scrollTo(0, 0);
      })
    },
    showUpdateSuccess() {
      this.updateSucessCd = this.dismissSecs;
    },
    status(validation) {
      return {
        error: validation.$error,
        dirty: validation.$dirty
      }
    },
    setSearch(input) {
      this.searchInput.value = input;
      this.getDataList();
    },
    setPerPage(amount) {
      // console.log(amount);
      this.rowsPerPage.value = amount;
      this.pagination.currentPage = 1;
      this.getDataList();
    },
    setCurrentPage(currentPage) {
      // console.log(currentPage);
      this.pagination.currentPage = currentPage;
      this.getDataList();
    },
    getDataList() {
      var params = {
        page: this.pagination.currentPage,
        count: this.rowsPerPage.value
      }
      if (this.searchInput.value.trim().length > 0) {
        params = {
          ...params,
          ...{ search: this.searchInput.value }
        }
      }
      if (this.policyType.value != null) {
        params = {
          ...params,
          ...{ policyType: this.policyType.value }
        }
      }
      if (this.workFlowStep.value != null) {
        params = {
          ...params,
          ...{ workFlowStep: this.workFlowStep.value }
        }
      }
      if (this.policyStatus.value != null) {
        params = {
          ...params,
          ...{ policyStatus: this.policyStatus.value }
        }
      }
      if (this.sorting.orderBy) {
        params = {
          ...params,
          ...{ orderBy: this.sorting.orderBy },
          ...{ direction: this.sorting.direction }
        }
      }
      this.$store.dispatch('LifePolicy/getLifeList', params).then((data) => {
        console.debug(data);
        Vue.set(this, 'dataList', data.list);
        Vue.set(this.totalItems, 'total', data.total)
      });
    },
    onClickDropdown(actionType, item) {
      var policyID = item.ID;
      var workFlowStep = item.workFlowStep;
      var policyNumber = item.policyNumber;
      var policyReference = item.policyReference;
      var productEnglishName = item.productEnglishName;
      var productChineseName = item.productChineseName;
      this.$store.commit({ type: 'LifePolicy/setLifePolicyID', policyID: policyID });
      Vue.set(this, 'clickedRow', {
        policyNumber: policyNumber,
        policyReference: policyReference,
        policyID: policyID,
        policyOwner: this.$options.filters.capitalizeLastName(item.englishLastnamePolicyOwner) + ' ' + item.englishFirstnamePolicyOwner + ' ' +
          item.chineseLastnamePolicyOwner + item.chineseFirstnamePolicyOwner
      });
      // console.debug(policyID);
      var wfStep = parseInt(workFlowStep);
      // console.debug(wfStep);
      switch (actionType) {
        case 'renewal':
          let detail = {
            policyID: policyID,
            policyNumber: policyNumber,
            productChineseName: productChineseName,
            productEnglishName: productEnglishName,
            modalPremium: item.modalPremium
          };
          this.$router.push({
            name: 'Renew Life Policy',
            params: { detail: detail }
          })
          break;
        case 'delete':
          this.$refs.modal.openModal();
          break;
        case 'serviceRequest':
          console.debug('lifePolicyList', {
            policy: {
              policyID: policyID,
              policyType: 'P'
            }
          });
          this.$router.push({
            name: 'Select Service Request',
            params: {
              policy: {
                policyID: policyID,
                policyType: 'P'
              }
            }
          })
          break;
        case 'outstanding':
          this.$router.push('/osm/life/or');
          break;
        case 'transferOut':
          Vue.set(this, 'selectedChangeBusinessAction', 'transferOut');
          this.$refs.cbModal.show();
          break;
        case 'coolingOff':
          Vue.set(this, 'selectedChangeBusinessAction', 'coolingOff');
          this.$refs.cbModal.show();
          break;
        case 'lapse':
          Vue.set(this, 'selectedChangeBusinessAction', 'lapse');
          this.$refs.cbModal.show();
          break;
        case 'claim':
          var policyDetail = {
            policyID: policyID,
            productChineseName: productChineseName,
            productEnglishName: productEnglishName,
            policyType: 'P'
          }
          this.$router.push({
            name: 'Create Claim',
            params: { detail: policyDetail }
          });
          break;
        case 'detail':
          switch (wfStep) {
            case 8:
              this.$store.commit({ type: 'LifePolicy/setIsCompleted', value: true })
              this.$router.push({
                path: '/osm/life/detail',
                query: { ID: policyID }
              })
              // this.$store.dispatch('lifePolicy/setWorkflowCurrentStep', wfStep)
              return;
            case 5:
            case 6:
            case 7:
              this.$store.dispatch('LifePolicy/setWorkflowCurrentStep', (wfStep + 1))
              break;
            case 4:
              this.$store.commit({ type: 'LifePolicy/setIsRejected', value: true })
            default:
              this.$store.dispatch('LifePolicy/setWorkflowCurrentStep', wfStep)
              break;
          }
          this.$router.push('/osm/life/new')
          break;
      }
    },
    createAction(action) {
      this.actions.value.action = action;
      // this.showModal({ rowID: '', action: 'Create' })
    },
    getOptions() {
      this.$store.dispatch('getAllSelections', "life").then((response) => {
        if (response.status != 200) {
          return;
        }
        Vue.set(this, 'allSelections', response.data);
      }, )
    },
    getSpecificTranslatedOptions(fieldName) {
      var obj = this.allSelections.filter((item) => { return item.name === fieldName });
      if (obj[0] == null) {
        return []
      }
      if (obj[0].options.length == 0) {
        return null;
      }
      var translatedData = this.getTranslatedOptions(this.$i18n.locale, obj[0].options);
      translatedData.unshift({ value: null, text: this.$t('general.all') });
      return translatedData
    },
    getTranslatedPolicyField(fieldName, key) {
      var obj = this.allSelections.filter((item) => { return item.name === fieldName });
      if (obj[0] == null) {
        return []
      }
      if (obj[0].options.length == 0) {
        return null;
      }
      var filteredType = obj[0].options.filter((item) => {
        return item.selectionKey === key
      });
      var translatedData = this.getTranslatedOptions(this.$i18n.locale, filteredType);
      if (translatedData.length == 0) {
        return 'N/A'
      }
      return translatedData[0].text
    }

  },
  data() {
    return {
      selectedChangeBusinessAction: '',
      selectedRow: {},
      cb: {
        changeBusinessEffectDate: '',
        isFirstTimeClickedModalOk: true,
        newFileUploaded: {},
      },
      sorting: {
        sortBy: null,
        sortDesc: null
      },
      alertParams: {
        content: '',
        variant: 'success'
      },
      clickedRow: {
        policyNumber: -1,
        policyReference: -1,
        policyID: -1
      },
      dismissSecs: 3,
      updateSucessCd: 0,
      slots: [
        'policyType'
      ],

      pagination: {
        currentPage: 1,
      },
      searchInput: {
        value: '',
        placeholder: this.$t('general.search')
      },
      rowsPerPage: {
        value: 25,
        options: [10, 25, 50, 100],
        label: this.$t("general.pagination")
      },
      workFlowStep: {
        value: null,
      },
      policyType: {
        value: null,
        key: 'policyType',
        label: 'Policy Type'
      },
      policyStatus: { value: null },
      fields: [{
          key: 'policyNumber',
          label: this.$t('osm.contents.lifePolicy.generalInformation.policyNumber'),
          sortable: true
        },
        {
          key: 'policyReference',
          label: this.$t('osm.contents.lifePolicy.generalInformation.policyReference'),
          sortable: true
        },
        {
          key: 'productName',
          label: this.$t('osm.contents.lifePolicy.generalInformation.productName'),
        },
        {
          key: 'policyOwnerName',
          label: this.$t('osm.contents.lifePolicy.generalInformation.policyOwner'),
        },
        {
          key: 'currentAgentName',
          label: this.$t('osm.contents.lifePolicy.generalInformation.currentAgent'),
        },
        {
          key: 'workFlowStep',
          label: this.$t('osm.contents.general.workFlowStep'),
          sortable: true
        },
        {
          key: 'policyStatus',
          label: this.$t('osm.contents.general.policyStatus'),
          sortable: true
        },
        {
          key: 'approveAgentName',
          label: this.$t('osm.contents.lifePolicy.generalInformation.approveAgent'),
        },
        {
          key: 'updateTime',
          label: this.$t('osm.contents.general.updateTime'),
        },
        {
          key: 'actions',
          label: this.$t('osm.contents.general.actions')
        }
      ],
      actions: {
        value: { rowID: '', action: '' },
        key: 'actions',
        label: this.$t('osm.contents.general.actions'),
        options: [
          { text: this.$t('osm.contents.general.detail'), key: 'detail' },
          { text: this.$t('osm.contents.general.outstandingRequirement.title'), key: 'outstanding' },
          { text: this.$t('osm.renewal.renewLife.header'), key: 'renewal' },
          { text: this.$t('osm.serviceRequest.header'), key: 'serviceRequest' },
          { text: this.$t('osm.contents.general.changeBusiness.transferOut'), key: 'transferOut' },
          { text: this.$t('osm.contents.general.changeBusiness.coolingOff'), key: 'coolingOff' },
          { text: this.$t('osm.contents.general.changeBusiness.lapse'), key: 'lapse' },
          { text: this.$t('osm.claim.apply'), key: 'claim' },
          { text: this.$t('osm.contents.general.delete'), key: 'delete', class: 'text-danger' }
        ]
      },
      totalItems: {
        preFix: this.$t("general.total"),
        postFix: this.$t("general.records"),
        total: 0
      },
      dataList: [],
      allSelections: [],
    }
  },
  watch: {
    sorting: {
      deep: true,
      handler(val) {
        console.debug(val);
        this.getDataList();
      }
    }
  }
}

</script>
<style type="text/css">
.minTableHeight {
  min-height: 300px;
}

</style>



// WEBPACK FOOTER //
// src/Osm/LifePolicy/containers/LifePolicyList.vue